export default __webpack_public_path__ + "static/media/step3-b.fb42c189.png";